import landing from "./landing";
import auth from "./auth.ts";
import registration from "./registration.ts";
import balance from "./balance.ts";
import organization from "./organization";
import shop from "./shop";
import tariff from "./tariff";
import employee from "./employee";
import documents from "./documents";
import history from "./history";
import clients from "./clients";
import wallet from "./wallet";
import files from "./files";
import catalog from "./catalog";
import promotions from "./promotions";
import reviews from "./reviews";
import spread from "./spread";
import managers from "./managers";
import permissions from "./permissions";
import profile from "./profile";
import app from "./app";
import faq from "./faq";
import pushs from "./pushs";
import cashback from "./cashback";

export default {
  auth,
  registration,
  balance,
  organization,
  shop,
  landing,
  tariff,
  employee,
  documents,
  history,
  clients,
  wallet,
  catalog,
  promotions,
  reviews,
  spread,
  managers,
  files,
  permissions,
  profile,
  faq,
  app,
  pushs,
  cashback,

  //SYSTEM
  sys: {
    error: "Ошибка: ",
    descError: "Описание: ",
    wrongLogin: "Неверный логин",
    wrongPass: "Неверный пароль",
    unknown: "Не известно",
    unauthenticated: "Не авторизован",
    iikAlready: "Юридическое лицо с этим ИИК уже существует",
    noMoney: "Недостаточно средств на балансе",
    wrongPeriod: "ProPlus только на год",
    noPermissions: "У пользователя нет необходимых разрешений.",
    firstLoginManager: "Впервые выполнен вход, придумайте пароль",
    limitShops: "Создание торговой точки ограничено тарифом",
    limitLegalEntity: "Создание юридического лица ограничено тарифом",
    wrongTariff: "На вашем тарифе это недоступно",
    wrongTariffPromo: "Промокод не подходит для регистрации",
    tagExist: "Этот тег уже существует",
    503: "Сервер недоступен",
    blockManager: "Менеджер заблокирован",
    wrongCode: "Неверный код",
    codeExists: "Промокод партнера введен не верно",
    noExam: "Экзамен не сдан",
    noActivateAccount: "Аккаунт не активирован",
    emailExist:
      "Владелец с данной почтой уже зарегистрирован в сервисах RC GROUP",
    userExist:
      "Владелец с данной почтой уже зарегистрирован в сервисах RC GROUP",
    noAccepted: "Новое соглашение не принято",
    balanceNotEnough: "Недостаточно средств на балансе",
    innExist: "Юридическое лицо с этим ИНН уже существует",
    noTodayChangeTariff:
      "Изменить тариф можно только за день до окончания текущего тарифа",
    badToken: "Данная ссылка не действительна",
    wrongEmail: "Неправильная почта",
    emailTaken: "Электронный адрес уже занят",
    notAvailableCurrentTariff: "Недоступно текущему тарифу",
    dataNoCorrect: "Данные неверны",
    accountNotFound: "Аккаунт не найден",
    TPExist: "Торговая точка уже существует",
    serverError: "Ошибка сервера",
    ownerExist: "Аккаунт не найден",
    unauthorizedAction: "У вас недостаточно прав",
    legalEntityExist: "Юридическое лицо не найдено",
    tariffChangeOneDay:
      "Тариф можно изменить за сутки до окончания текущего тарифа",
    blockedByTariff: "Заблокирована по тарифу",
    documentInProcessOfCreation: "Документ в процессе формирования",
    emailAlreadyVerified: "Ваша почта уже подтверждена!",
    emailConfirmed: "Ваша почта успешно подтверждена!",
    codeDoesNotExist: "Введенный код недействителен",
    defaultCashbackCanNotBeDeleted:
      "Вознаграждение для клиентов без брендированной карты не может быть удалено",
    cashbackUpdateSuccessful: "Процент вознаграждения был успешно обновлен",
    cashbackDeleteSuccessful: "Вознаграждение удалено",
    cashbackCreateSuccessful: "Вознаграждение создано",
    fullCashback: "Клиент без брендированной карты",
    clientGroupAlreadyInUse:
      "Группа клиентов уже используется в группе кешбека",
    enteredAmountIsAlreadyInUse:
      "Введенная сумма вознаграждения уже выставлена",
    dateStartIsInvalid: "Дата начала периода введена некорректно",
    dateEndIsInvalid: "Дата конца периода введена некорректно",
    organizationNotConfirmed: "Юр.лицо не подтверждено",
    periodNotAvailable: "Выбранный период недоступен для покупки",
    notAvailableInYourCountry: "Выбранный период недоступен для покупки",
    exceededActivatedPromotionLimit:
      "Только 3 активированных акции на одну торговую точку",
    tradingPointLimitOnProPlus:
      "На тарифе ProPlus возможно создание не более 30 торговых точек",
    tradingPointLimitOnPromo:
      "На тарифе ProPlus возможно создание не более 15 торговых точек",
    tradingPointLimitOnLight:
      "На тарифе ProPlus возможно создание не более 5 торговых точек",
    wrongDateOrder:
      "Дата начала периода должна быть раньше, чем дата конца периода",
    descriptionFormatInvalid: "Описание не должно содержать хештегов и emoji",
    descriptionMustNotContainEmoji: "Описание не должно содержать emoji",
    descriptionMinLength:
      "Описание должно быть длинее 600 символов без учета пробелов",
    descriptionMaxLength: "Описание не должно быть длинее 3000 символов",
    maxFileSizeError: "Размер файла превышает лимит в 10 Мбайт",
    addFile:
      "Перетащите или <span style='color: #447ECB; cursor: pointer'>загрузите файлы</span>",
    balance: "Баланс",
    changeMainOrganizationError:
      "Изменить главную организацию возможно только через 30 дней после предыдущего изменения",
    resetWallet: "Не удалось сбросить дизайн wallet pass",
    updateWallet: "Не удалось обновить дизайн wallet pass",
    userUnauthorized: "Логин или пароль введены неверно",
    noData: "Нет данных",
    pageUnavailableYet: "Страница пока недоступна",
    kb: "КБ",
    dateMask: "дд.мм.гггг",
    sort: "Сортировка",
    noDataTitle: "Данных пока нет",
    syncError: "Проблема с синхронизацией. Попробуйте еще раз позже.",

    enterName: "Введите название",
    countries: {
      ru: "Россия",
      kz: "Казахстан",
      md: "Молдова",
      ky: "Кыргызстан",
      uz: "Узбекистан",
    },
    select_country: "Выберите страну",
    country: "Страна",
    q_date: {
      days: "Воскресенье_Понедельник_Вторник_Среда_Четверг_Пятница_Суббота",
      daysShort: "Вс_Пн_Вт_Ср_Чт_Пт_Сб",
      months:
        "Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь",
      monthsShort: "Янв_Фев_Мар_Апр_Май_Июн_Июл_Авг_Сен_Окт_Ноя_Дек",
    },
    errorTitle: "Что-то пошло не так",
    dateFrom: "Данные доступны с ",
    dateToToday: " по сегодняшний день",
    dateFormat: "Формат дд.мм.гггг или дд.мм.гггг - дд.мм.гггг",
    showBy: "Показывать по: ",
    showByMobile: "По: ",
    searchResponseEmpty: "По вашему запросу ничего не найдено",
    search: "Поиск",
    imageSize: "Мб",
    tagSearchResponseEmpty:
      "Тег не найден. Для его добавления нажмите Enter или Пробел.",
    from: "От:",
    to: "До:",
    gender: {
      m: "Мужской",
      f: "Женский",
    },
    500: "Что-то пошло не так. Что-то пошло не так. Проверьте интернет-соединение.",
    soon: "Скоро!",
    fromToPercent: "От {from} до {to} %",
    fromToDays: "От {from} до {to} дней",
    timeFormat: "чч:мм – чч:мм",
    language: "Язык",
    copied: "Скопировано",
    moderationMessage: "Сообщение от модерации",
    languageSelecting: "Выбор языка",
    showMap: "Показать карту",
    hideMap: "Скрыть карту",
  },

  message: {
    changesSavedAndSendedToModeration:
      "Изменения сохранены и отправлены на модерацию",
    changesSuccessSaved: "Изменения успешно сохранены",
    changesSaved: "Изменения сохранены",
  },

  entity: {
    title: "Добавьте данные организации",
    thirdStepTitle:
      "Пожалуйста, проверьте правильность данных. Теперь вам необходимо подождать от 24 до 48 часов, что бы мы подтвердили ваше юридическое лицо.",
    accept: "Я принимаю условия договора",
    offers: "оферты",
    titleReject: "Заявка отклонена!",
    rejectDescription:
      "К сожалению, предоставленные вами данные оказались некорректными. Внимательно ознакомьтесь с ответом от модераторов и внесите изменения в информацию о юридическом лице.",
    message: "Сообщение от модераторов:",
    change: "Изменить данные",
    // titleWaiting: "Спасибо за ожидание", - изменено от (NK-589)
    titleWaiting: "Спасибо за регистрацию!",
    descriptionWaiting:
      "В данный момент ваша организация проходит модерацию. Вы сможете попасть в личный кабинет после того, как мы удостоверимся в корректности ваших данных. Как правило, проверка занимает от 24 до 48 часов.",
    descriptionWaitingRu:
      "<p>В данный момент ваша организация проходит модерацию. </p> <p>После того, как мы удостоверимся в корректности ваших данных \n" +
      "вы сможете войти в кабинет партнёра RC Group. </p>  <p> Как правило, проверка занимает от 24 до 48 часов.</p>",
    descriptionWaitingRuWithoutPos:
      "<p>В данный момент ваша организация проходит модерацию. </p> <p>После того, как мы удостоверимся в корректности ваших данных \n" +
      "вы сможете войти в кабинет партнёра RC Group. </p> <p> Как правило, проверка занимает от 24 до 48 часов.</p>",
    // downloadAccept: "Скачать счет по акцептному платежу", - изменено от (NK-589)
    downloadAccept: "Скачать счет на оплату",
    addDone: "Поздравляем с созданием юрлица!",
    waitingApprove:
      "<p>В данный момент ваше юрлицо проходит проверку. Она занимает от 24 до 48 часов.</p><p>Для прохождения проверки вам необходимо оплатить счет с указанного юрлица, скачав его по кнопке ниже. Вы также можете найти счет в личном кабинете: в разделе «Мои  предприятия» - «Документы» под названием «Тестовый платеж».</p>",
  },

  contacts: {
    title: "Контакты",
    subtitle:
      '<span>АКЦИОНЕРНОЕ ОБЩЕСТВО "КОРПОРАЦИЯ "ИНФОРМАЦИОННО-ФИНАНСОВЫЕ ТЕХНОЛОГИИ" (АО «Корпорация «Инфинтех»)</span><span>Юридический адрес: 191124, город Санкт-Петербург, ул. Красного Текстильщика, д. 10-12 литера О, этаж 6 помещ. 1-н кабинет 624 </span><span>ИНН/КПП 7842216564/784201001 ОГРН 1237800080616</span>',
    mailAddress: "Адрес электронной почты: ",
  },

  failed: "Ошибка. Действие не выполнено",
  success: "Действие выполнено",

  //cabinet layout
  leftPanel: {
    counterparties: "Проверка контрагентов",
    entities: "Юрлица",
    tradingPoint: "Торговые точки",
    paymentMethods: "Способы оплаты",
    employees: "Кассиры",
    documents: "Документы",
    businesses: "Бизнес",
    tariffs: "Тарифы",
    historyPayment: "История операций",
    promotions: "Акции",
    actsAndAccounts: "Акты и счета",
    accrualCashback: "Начисление баллов",
    managers: "Менеджеры",
    spread: "Распространение карт RC",
    analytics: "Аналитика",
    points: "Очки кассирам",
    enterprises: "Мои предприятия",
    paymentDecision: "Платежное решение",
    portfolio: "Портфель",
    employees_and_managers: "Мои сотрудники",
    loyalty: "Программа лояльности",
    clients: "Клиенты",
    claims: "Заявки",
    claims_history: "История заявок",
    claims_groups: "Группировка клиентов",
    reviews: "Отзывы",
    extendTariff: "Продлите действие тарифа",
    changeTo: "тариф изменится на",
    wallet: "Дизайн карты Wallet",
    accountIs: "Вы вошли как",
    manager: "менеджер",
    owner: "владелец",
    terminals: "Кассовые аппараты",
    terminals_MSPOS: "RC Processing 4 в 1",
    terminals_LIMON: "Технология MPOS",
    FAQ: "Подробно об RC CITY",
    corporate: "Связь",
    push: "Push-уведомления Wallet",
    tips: "Безналичные чаевые",
    eMenu: "Онлайн-каталог",
    documentLaboratory: "Лаборатория документов",
    giftCard: "Подарочные карты",
    processing: "Processing",
    services: "Сервисы",
    wallets: "Карты лояльности",
    clientsList: "Список клиентов",
    marketplaces: "Маркетплейсы",
    PromotionServices: "Продвижение",
    PreOrders: "Заказы",
    PWA: "Установить приложение",
    tgNotifications: "Уведомления в Telegram",
  },
  headerButtons: {
    addCoin: "Пополнить",
    profile: "Профиль",
    exit: "Выйти",
    themLight: "Светлая тема",
    themDark: "Темная тема",
  },

  //check counterparties page
  counterparties: {
    title: "Проверка контрагентов",
    buttonCheck: "Проверить",
    question:
      "Дата регистрации, ИНН, КПП, ОГРН,  Основной вид деятельности, Статус юрлица,ИФНС, Юридический адрес, Ген. директор, Учредители, Уставный капитал",
    instructionButton: "Инструкция для проверки контрагентов",
    listTitle: "Как использовать Бот для проверки контрагентов?",
    listItemFirst:
      "Введите ИНН или ОГРН организации, которую собираетесь проверять.",
    listItemSecond: "Telegram-Бот покажет вам всю необходимую информацию.",
    listItemThird:
      "Для проверки блокированных счетов нужно нажать на кнопку «Проверить блокировку счетов».",
    listItemFourth:
      "После нажатия на кнопку «Проверить блокировку счетов» Бот покажет все заблокированные счета (при их наличии), ФНС, дату блокировки, № постановления, основание  в соответствии со статьей. Данную информацию можно скачать в PDF-формате для подробного изучения: нажмите кнопку «Скачать файл отчетом».",
    instructionCardTitleFirst: "Зачем проверять контрагентов?",
    instructionCardTitleSecond: "Своевременно узнавайте о фактах.",
    instructionCardTextFirst:
      "<p>Проверка контрагентов необходима для оперативного выявления финансовых и налоговых рисков, которые могут возникнуть при работе с контрагентом, и принятия обоснованных решений — продолжить или прекратить сотрудничество. <br> Бот автоматически проверяет новых и текущих контрагентов по разным источникам и сообщает вам о критических факторах и сведениях, требующих внимания.</p>",
    instructionCardTextSecond:
      "<p>С помощью бота вы можете проводить массовую проверку и мониторинг изменений по всей базе контрагентов или по конкретной выделенной. Это позволяет вовремя реагировать на существенные изменения у клиентов и партнеров, снижая риск невозврата денежных средств.</p>",
  },

  // Claims and history claims page
  claims: {
    title: "Заявки",
    historytitle: "История заявок",
    group_name: "Название группы",
    group_nomination: "Наименование группы",
    group_sum: "Сумма покупок (без учета скидок)",
    create_group: "Создать новую группу",
    edit_group: "Редактировать группу",
    delete_group: "Вы уверены что хотите удалить группу?",
    sum: "Сумма",
    percent: "Процент начисления",
    noClients: "Пока что у вас не было ни одного клиента",
    oneClient: "У вас был только один клиент",
  },

  //analytic page
  analytics: {
    title: "Аналитика",
    organizationSelect: "Выберите Юр лицо",
    organizationButton: "Юрлица",
    organizationCheckbox: "Все организации",
    newOrganizationCheckbox: "Все Юрлица",
    calendar: "Календарь",
    organizations: {
      newClients: "Новые клиенты",
      allClients: "Все клиенты",
      sales: "Продажи",
      amount: "Сумма продаж",
      amountCashback: "Из них выдано баллами",
      average: "Средний чек",
      averageCashback: "Среднее вознаграждение",
      ofThem: "Из них",
      awardedInPoints: "выдано баллами",
      acceptedWithPoints: "принято баллами",
      acceptedWithPointsTitle: "Принято баллами",
    },
    filterTitles: { entity: "Юрлицо", tradingPoints: "Торговые точки" },
    countClients: "Количество клиентов",
    topSumEmployee: "Топ кассиров по сумме продаж",
    topSaleEmployee: " Топ кассиров по продажам",
    points: "Очки",
    addPoints: "Начис. баллы",
    writePoints: "Принято баллами",
    rfmAnalysis: "RFM Анализ",
    rfmGroupSizes: "Размер RFM групп",
    clientPortrait: {
      btn: "Портрет клиента",
      title: "Клиенты",
      customerCount: "Количество клиентов:",
      receiptAvg: "Средний чек:",
      receiptCount: "Количество продаж:",
      receiptSum: "Сумма продаж:",
      maleFemale: "М/Ж:",
      noGender: "Пол не указан:",
    },
  }, // Cashback page
  // cashback: {
  //   statusName: "Клиенты без брендированной карты",
  // },

  // Answer moderation
  status: {
    moderation: "На модерации",
    confirmation: "Подтверждено",
    confirm: "Подтвержден",
    reject: "Отклонено",
    reject2: "Отклонен",
    paid: "Оплачено",
    active: "Активен",
    locked: "Заблокирован",
    activateProcess: "В процессе активации",
    awaitingPayment: "Ожидает оплаты",
    sent: "Отправлен",
    received: "Получен",
    canceled: "Отменен",
    unknown: "Неизвестно",
    awaitingDocs: "Ожидает загрузки документа",
    base: "Базовая",
    inProgress: "В работе",
    completed: "Завершен",
    new: "Новый",
    readyForIssue: "Готов к выдаче",
    issuedToClient: "Выдан клиенту",
    undefined: "Неизвестен",
    performed: "Проведен",
    inWaiting: "В ожидании",
  },

  // Table
  table: {
    searchByTable: "Поиск по таблице",
    status: "Статус",
    nameStatus: "Название статуса",
    percentageAccrual: "Процент начисления",
    fullName: "ФИО",
    position: "Должность",
    phone: "Номер телефона",
    login: "Логин",
    number: "Номер",
    sum: "Сумма",
    customer: "Покупатель",
    cashback: "Баллы",
    currency: "Валюта",
    dateTime: "Дата и время",
    date: "Дата",
    paid: "Оплачено",
    purchase: "С покупки на",
    transaction: "Транзакция",
    type: "Тип",
    points: "Очки",
    name: "Имя",
    visits: "Частота визитов",
    averageCheck: "Сумма покупок",
    birthday: "День рождения",
    age: "Возраст",
    nameAndSurname: "Фамилия и Имя",
    store: "Торговая точка",
    entityName: "Название организации",
    operationType: "Тип операции",
    time: "Время",
  },

  // Common text
  common: {
    nodata: "У вас еще нет торговой точки",
    buttonNoData: "Создать торговую точку",
    organizationSelect: "Выберите организацию",
    allOrganizationCheckbox: "",
    tradingPointsSelect: "Выберите торговую точку",
    allTradingPointsCheckbox: "Все торговые точки",
    from: "c",
    util: "до",
    to: "по",
    fillField: "Заполните это поле",
    invalidEmail: "Неверная почта",
    minLengthPass: "Пароль не меньше 8 символов",
    fillTime: "Заполните время",
    calendar: "Календарь",
    filter: "Фильтр",
    filters: "Фильтры",
    back: "Назад",
    loadDescription: "Пожалуйста, загрузите сертификат халяльности продукции:",
    loadFormat: "Поддерживаются сертификаты в формате .PDF .JPG .PNG",
    loadSize: "Вес файла может быть не более 10 МБ",
    dropFiles: "Перетащите файл сюда или",
    uploadFiles: "загрузите",
    chooseFile: "Выбрать файл",
    fileName: "Имя файла",
    Monday: "Понедельник",
    Tuesday: "Вторник",
    Wednesday: "Среда",
    Thursday: "Четверг",
    Friday: "Пятница",
    Saturday: "Суббота",
    Sunday: "Воскресенье",
    MondayShort: "Пн",
    TuesdayShort: "Вт",
    WednesdayShort: "Ср",
    ThursdayShort: "Чт",
    FridayShort: "Пт",
    SaturdayShort: "Сб",
    SundayShort: "Вс",
    1: "Понедельник",
    2: "Вторник",
    3: "Среда",
    4: "Четверг",
    5: "Пятница",
    6: "Суббота",
    7: "Воскресенье",
    dayAndNightTime: "Точка работает круглосуточно",
    notWorkTime: "Точка не работает",
    month: "месяц",
    mo: "мес",
    year: "год",
    organizations: "Организации",
    shops: "Торговые точки",
    employees: "Кассиры",
    managers: "Менеджеры",
    manager: "Менеджер",
    owner: "Владелец",
    business: "Бизнес",
    tariffs: "Тарифы",
    historyOperations: "История операций",
    actsAndAccounts: "Акты и счета",
    cashback: "Начисление баллов",
    documents: "Документы",
    addBalance: "Авансовый платеж",
    addPoints: "Начисление очков",
    application: "Оплата кассового аппарата",
    claims: "Заявки",
    analytics: "Аналитика",
    sortNew: "По новизне",
    sortAscStars: "По убыванию звезд",
    sortDscStars: "По возрастанию звезд",
    email: "email",
    lastName: "Фамилия",
    firstName: "Имя",
    error404: "Ошибка 404",
    noPage: "Страница не найдена",
    errorTypeFile: "Не верный тип файла!",
    tryTypeFile: "Файл должен быть jpg или png",
    clients: "Клиенты",
    exitAccount: "Выйти из аккаунта",
    accountsForAct: "Счет по акту",
    downloadOn: "доступно в",
    downloadOnRuStore: "скачайте из",
    phone: "Телефон",
    comment: "Комментарий",
    pcs: "шт",
    gb: "ГБ",
    min: "мин",
    group: "Группа",
    emptyField: "Заполните все поля",
    correctField: "Все поля должны быть корректны!",
    bigFile: "Большой размер файла",
    "e-menu": "Электронное меню",
    "document-laboratory": "Лаборатория документов",
    changesNotSaved: "Внесенные изменения не были сохранены",
    statuses: "Статусы",
    phoneNumber: "Номер телефона",
    mail: "Электронная почта",
    tgBot: "Telegram бот",
  },

  // Buttons
  button: {
    invite: "Пригласить",
    download: "Скачать",
    edit: "Редактировать",
    save: "Сохранить",
    saveChange: "Сохранить изменения",
    saveAndQuit: "Сохранить и выйти",
    accept: "Принять",
    change: "Изменить",
    login: "Войти",
    create: "Создать",
    confirm: "Подтвердить",
    details: "Подробнее",
    copy: "Скопировать",
    topUp: "Пополнить",
    back: "Назад",
    send: "Отправить",
    sendAgain: "Отправить повторно",
    sendCode: "Отправить код",
    next: "Далее",
    proceed: "Продолжить",
    buy: "Купить",
    goto: "Перейти",
    open: "Открыть",
    delete: "Удалить",
    cancel: "Отмена",
    cancel2: "Отменить",
    yesCancel: "Да, отменить",
    yesQuit: "Да, выйти",
    yesDelete: "Да, удалить",
    pay: "Оплатить",
    ok: "Хорошо!",
    cancelClaim: "Отменить заявку",
    generate: "Сгенерировать",
    apply: "Применить",
    applyAndClose: "Применить и закрыть",
    reset: "Сбросить",
    clearAll: "Очистить все",
    calendarButton: {
      today: "Сегодня",
      yesterday: "Вчера",
      lastWeek: "Последние 7 дней",
      last30Days: "Последние 30 дней",
      lastMonth: "Прошлый месяц",
      thisMonth: "Этот месяц",
      lastYear: "Последний год",
      thisYear: "Этот год",
      allPeriod: "Весь период",
      selectRange: "Свой период",
    },
    preview: "Предпросмотр",
    resetAll: "Сбросить все",
    showResult: "Показать результаты",
    upload: "Загрузить",
    expand: "Развернуть",
    hide: "Скрыть",
    try: "Попробовать",
    add: "Добавить",
    reveal: "Показать",
    readAll: "Читать полностью",
    logout: "Выйти",
    show: "Показать",
    moreDetails: "Подробнее",
    settings: "Настройки",
    rollUp: "Свернуть",
    rollUpAll: "Свернуть все",
    toTariffs: "К тарифам",
    forModeration: "На модерацию",
    quitWithoutSaving: "Выйти без сохранения",
    downloadInvoice: "Скачать счет",
    notNow: "Не сейчас",
    createCashier: "Создать кассира",
    clearly: "Понятно",
    toEdit: "К редактированию",
    skip: "Пропустить",
    backAndSave: "Вернуться и сохранить",
    done: "Готово",
    close: "Закрыть",
  },

  month: {
    1: "Январь",
    2: "Февраль",
    3: "Март",
    4: "Апрель",
    5: "Май",
    6: "Июнь",
    7: "Июль",
    8: "Август",
    9: "Сентябрь",
    10: "Октябрь",
    11: "Ноябрь",
    12: "Декабрь",
  },

  charts: {
    pointsAccrued: "Начисленные баллы",
    pointsWritten: "Принято баллами",
  },

  eMenu: {
    noData: {
      title: "Данных по электронному меню нет",
      noTradingPoints: "У вас пока нет Торговых точек ",
      noProducts: "У вас пока не создано ни одного товара",
    },
  },

  validationErrors: {
    emptyField: "Поле не может быть пустым",
    invalidEmailFormat: "Введите email вида {email}",
    invalidSiteFormat: "URL должен содержать http:// или https://",
    invalidFormat: "Неверный формат",
    incorrectValueStart: "Необходимо указать значение от",
    incorrectValueEnd: "до",
    invalidValueMaxLength: "Максимальное количество символов ",
    invalidValueMinLength: "Минимальное количество символов ",
    invalidHouseNumber: "Уточните номер дома",
    invalidAddress: "Уточните адрес",
    writeFullAddress: "Уточните адрес: улицу, дом / здание / сооружение",
    invalidWorkDays: "Необходимо выбрать хотя бы один рабочий день",
    invalidWorkTime: "Неверный формат времени",
    errorWorkTime:
      "Время открытия не может быть позже времени закрытия или совпадать с ним",
    notEnoughElement: "Недостаточное количество элементов",
    manyElement: "Вы превысили максимальное количество элементов",
    maxLessMin: "Меньше минимального",
    invalidAge: "Некоректный возраст",
    minDate: "Дата должна быть не позднее {date}",
    maxDate: "Дата должна быть не ранее {date}",
    requiredPhone: "Введите номер телефона",
    reqiredPromocode: "Промокод введен неверно",
    requiredCountry: "Необходимо выбрать страну",
    havePhone: "Этот телефон уже зарегистрирован",
    haveMail: "Данная почта уже зарегистрирована",
    invalidEmail: "Некорректная почта",
    email: "Введите почту",
    first_name: "Введите имя",
    last_name: "Введите фамилию",
    password: "Введите пароль",
    corresp_account: "Необходимо указать корсчет",
    number_account: "Необходимо указать номер расчетного счета",
    commercial_account_number:
      "Расчетный счет должен принадлежать юрлицу или ИП",
    bik_of_bank: "Необходимо указать БИК банка",
    mfo_of_bank: "Необходимо указать МФО банка",
    name_of_bank: "Необходимо указать название банка",
    international_bank:
      "Необходимо указать международный номер банковского счета",
    vat_code: "Необходимо указать код НДС",
    inn: "Необходимо указать инн",
    entityAddress: "Необходимо указать юридический адрес",
    fullName: "Необходимо указать ФИО",
    ogrn: "Необходимо указать ОГРН",
    monthly_turnover: "Необходимо указать размер ежемесячного оборота",
    deposit_sum: "Необходимо указать размер депозита",
    tax_system: "Необходимо указать тип налогообложения",
    legal_type: "Необходимо указать форму юрлица",
    okved_code: "Необходимо указать основной вид деятельности",
    minFillingPhotos: "Минимальное количество файлов - {amount}",
    notValidPromocode: "Промокод не существует",
    cyrillicOnly: "Только кириллица и латиница",
    haveInn: "Юрлицо с этим {option} уже существует",
    addressWithoutNumber:
      "Необходимо указать номер здания/сооружения, помещения",
    login: "Введите логин",
    empryNamedField: "Необходимо указать {option}",
    passwordMismatch: "Пароли не совпадают",
    address: "Необходимо указать адрес с номером здания/сооружения, помещения",
    fieldLengthFromTo: "Поле должно содержать от {from} до {to} цифр",
    necessaryEnterMinChars: "Необходимо ввести не менее {minChars} символов",
    workHours: "Укажите часы работы в выбранные дни",
    timeFormat: "Некорректный формат времени",
    minImagesUpload: "Загрузите не менее {minImages} изображений",
    wrongMailOrPassword: "Неверная почта или пароль",
    wrongLoginOrPassword: "Неверный логин или пароль",
    needEnterMinRC: "Необходимо указать не менее {amount} RC",
  },

  tooltips: {
    registration: {
      deposit:
        "Минимальный остаток на счете. Сумма, которая остается на балансе при выводе средств.",
    },
  },

  globalMessagesButton: {
    "tt-update": "Перейти в новый подраздел “Торговые точки”",
    "clients-update": "Попробовать",
    "product-release": "Попробовать",
    "review-update-release": "Попробовать",
  },

  declinationHelperWords: {
    years: [" лет", " год", " года"],
    days: [" дней", " день", " дня"],
    grades: [" оценок", " оценка", " оценки"],
    symbols: [" символов", " символа", " символов"],
    result: [" рузальтатов", " результат", " результата"],
    review: [" отзывов", " отзыв", " отзыва"],
    star: [" звезд", " звезда", " звезды"],
    clients: [" клиентов", " клиент", " клиента"],
    product: [" товаров", " товар", " товара"],
    entities: [" юрлиц", " юрлицо", " юрлица"],
  },

  noData: {
    title: "Данных нет",
    emptyHistory: "Ваша история пуста",
  },

  mobileFiltersName: {
    "trading-points": "Торговые точки",
    category: "Категория",
    "product-status": "Статус товара",
    "review-status": "Тип отзыва",
    sort: "Сортировка",
    date: "Период",
  },

  debt: {
    title: "Задолженность",
    text:
      "Оплатите ее с помощью счета, отправленного на электронную почту, или создайте его самостоятельно\n" +
      "в разделе “Баланс”",
    link: "Перейти к погашению",
    message:
      "Вам необходимо оплатить задолженность в размере {debt}&nbsp;{currency} <br>" +
      "Оплату можно произвести одним из способов: создать счет в личном кабинете или скачать счет, отправленный на электронную почту.",
  },

  promotionServices: {
    servicesList: {
      "xxl-tag": {
        name: "XXL-размер карточки",
        description:
          "Увеличение размера карточки вашего заведения и размещение на ней бейджа «Топ место»",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Карточка вашего заведения будет увеличена в размере, а также выделена бейджем «Топ место» на странице «Заведения» на сайте rcpay.ru и в мобильном приложении RC PAY в рамках того города и категории, к которым оно относится.</p></li>" +
          "<li><span>●</span><p>Срок размещения – 1 неделя, 1 месяц или 3 месяца с момента оформления и оплаты заказа в кабинете партнера.</p></li>" +
          "<li><span>●</span><p>Выбрать срок размещения можно на этапе оформления заказа.</p></li>" +
          "<li><span>●</span><p>При заказе данной услуги в подарок вы также получаете особую метку вашего заведения на карте.</p></li>" +
          "</ul>",
      },
      tag: {
        name: "Бейдж «Топ место»",
        description:
          "Размещение на карточке вашего заведения бейджа «Топ место» и перемещение её выше в общем списке",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Карточка вашего заведения будет выделена бейджем «Топ место» и перемещена выше в списке на странице «Заведения» на сайте rcpay.ru и в мобильном приложении RC PAY в рамках того города и категории, к которым оно относится.</p></li>" +
          "<li><span>●</span><p>Срок размещения –  1 неделя, 2 недели, 1 месяц или 3 месяца с момента оформления и оплаты заказа в кабинете партнера.</p></li>" +
          "<li><span>●</span><p>Выбрать срок размещения можно на этапе оформления заказа.</p></li>" +
          "<li><span>●</span><p>При заказе данной услуги в подарок вы также получаете особую метку вашего заведения на карте.</p></li>" +
          "</ul>",
      },
      top: {
        name: "Топ 1 или 2 место",
        description:
          "Размещение карточки вашего заведения на 1 или 2 местах в списке (без изменения её внешнего вида и размера)",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Карточка вашего заведения будет размещена на 1 или 2 месте на странице «Заведения» на сайте rcpay.ru и в мобильном приложении RC PAY в рамках того города и категории, к которым оно относится.</p></li>" +
          "<li><span>●</span><p>Размещение на 1 или 2 месте определяется очередностью оформления заказа и оплаты данной услуги.</p></li>" +
          "<li><span>●</span><p>Срок размещения – 2 недели с момента оформления и оплаты заказа в кабинете партнера.</p></li>" +
          "<li><span>●</span><p>При заказе данной услуги в подарок вы также получаете особую метку вашего заведения на карте.</p></li>" +
          "</ul>",
      },
      hint: "В настоящий момент все доступные слоты по данной услуге в городе вашей торговой точки заняты. Заказ будет возможен с указанной даты.",
    },
    periodsList: {
      "7 days": "1 неделя",
      "14 days": "2 недели",
      "30 days": "1 месяц (30 дн)",
      "90 days": "3 месяца (90 дн)",
    },
  },
};
